import {
  HeadingGroup,
  OffCanvasLayout,
  Pagination,
  SearchFilters,
  Table,
  ConfirmationBox,
  ModalLayout,
} from "@wac-ui-dashboard/wac_component_library";
import { FaSort } from "react-icons/fa";
import useProgrammeList from "./useProgrammeList";
import UpdateProgramme from "../UpdateProgramme";
import Filter from "../Filter";
import Style from "../programme.module.scss";
import { ImageCard } from "../../Global/ImageCard";

const ProgrammeList = () => {
  const {
    programme,
    programmeState,
    activeId,
    currentPage,
    activeFilter,
    showCreateModal,
    paginationOptions,
    isFetching,
    isLoading,
    showDeleteModal,
    isEditData,
    imageData,
    showImageModal,
    titleImageData,
    listThumbnailImageData,
    bannerImageData,
    verticalImageData,
    showTitleImageModal,
    showListThumbnailImageModal,
    showBannerImageModal,
    showVerticalImageModal,
    filterShow,
    setFilterShow,
    handleCreateClick,
    closeDeleteModal,
    handlePagination,
    handlePageSize,
    refetch,
    handleSort,
    handleSearch,
    handleProgrammeDataEditClick,
    closeModal,
    deleteProgrammeDataClick,
    getRow,
    deleteProgramme,
    handleClearClick,
    tableFields,
    hasCreatePermission,
    hasEditPermission,
    hasViewPermission,
    hasDeletePermission,
  } = useProgrammeList();

  return (
   
        <>
          <HeadingGroup
            title={"Program"}
            buttonTitle={hasCreatePermission ?? false ? "Add New" : ""}
             extraClassName={`pro-mb-4`}
            handleClick={handleCreateClick}
          />
            <div className="col-12 pro-pb-6">
              <SearchFilters
                activeFilter={activeFilter}
                showFilters={true}
                onSearchInput={handleSearch}
                loading={isLoading}
                showActions={false}
                handleClear={handleClearClick}
                searchInputProps={{ value: programmeState?.search }}
                SearchIcon={
                  <span className="material-symbols-outlined"> search </span>
                }
                showDateRange={false}
                extraFilters={
                  <div className="col-auto">
                    <button
                    className={`pro-btn pro-btn-outline pro-h-100 pro-items-center`}
                    onClick={() => setFilterShow(true)}
                    >
                      <span className="material-symbols-outlined">tune</span>
                      <span>Filter</span>
                    </button>
                  </div>
                }
              />
            <Table
              data={programme?.data?.original?.data || []}
              uniqueID={"_id"}
              fields={tableFields}
              showCheckBox={
                hasEditPermission || hasDeletePermission ? true : false
              }
              SortIcon={<FaSort />}
              handleEdit={handleProgrammeDataEditClick}
              editIcon={<span className="material-symbols-outlined">edit</span>}
              handleDelete={deleteProgrammeDataClick}
              deleteIcon={
                <span className="material-symbols-outlined">delete</span>
              }
              handleSort={handleSort}
              getRow={getRow}
              loading={isFetching}
              perpage={programmeState.currentPageSize}
              assignable={false}
              multiSelect={false}
              clear={programmeState.clearSelection}
              editable={hasEditPermission ? true : false}
              deletable={hasDeletePermission ? true : false}
            />
            {programme?.data?.original?.data?.length > 0 && (
              <Pagination
                currentPage={currentPage}
                totalPageCount={programme?.data?.original?.last_page_number}
                onPageChange={handlePagination}
                options={paginationOptions}
                onActionChange={handlePageSize}
                center
              />
            )}
            </div>
            <ModalLayout
              centered
              show={showDeleteModal}
              handleClose={closeDeleteModal}
            >
              <div className="pro-m-5">
                <ConfirmationBox
                  title={`Are you sure you want to delete?`}
                  isRight={true}
                  cancelText={`Cancel`}
                  submitText={`Delete`}
                  cancelAction={closeDeleteModal}
                  submitAction={deleteProgramme}
                >
                  ConfirmationBox
                </ConfirmationBox>
              </div>
            </ModalLayout>

            <OffCanvasLayout
              show={showCreateModal}
              handleClose={closeModal}
              title={`${
                isEditData ? "Update Program Details" : "Create Program"
              }`}
              closeIcon={
                <span className="material-symbols-outlined"> close </span>
              }
              backdrop={"static"}
            >
              <UpdateProgramme
                activeId={activeId}
                refetch={refetch}
                isEditData={isEditData}
              />
            </OffCanvasLayout>

            <ModalLayout show={showImageModal} handleClose={closeModal}>
              <ImageCard data={imageData} handleClose={closeModal} />
            </ModalLayout>
            <ModalLayout show={showTitleImageModal} handleClose={closeModal}>
              <ImageCard data={titleImageData} handleClose={closeModal} />
            </ModalLayout>
            <ModalLayout show={showListThumbnailImageModal} handleClose={closeModal}>
              <ImageCard data={listThumbnailImageData} handleClose={closeModal} />
            </ModalLayout>
            <ModalLayout show={showBannerImageModal} handleClose={closeModal}>
              <ImageCard data={bannerImageData} handleClose={closeModal} />
            </ModalLayout>
            <ModalLayout show={showVerticalImageModal} handleClose={closeModal}>
              <ImageCard data={verticalImageData} handleClose={closeModal} />
            </ModalLayout>

            <OffCanvasLayout
              centered={true}
              show={filterShow}
              handleClose={() => {
                setFilterShow(false);
              }}
              title={"Filter"}
              closeIcon={
                <span className="material-symbols-outlined">close</span>
              }
            >
              <Filter setShowform={setFilterShow} refetch={refetch}/>
            </OffCanvasLayout>
        </>
  );
};

export default ProgrammeList;
